// removed by extract-text-webpack-plugin
module.exports = {"apps-container":"apps-container","app-card":"app-card","app-icon":"app-icon","app-pgs":"app-pgs","app-pgd":"app-pgd","app-azf":"app-azf","app-ecs":"app-ecs","array-pgt":"array-pgt","app-name":"app-name","card-shadow":"card-shadow","azf":"azf","pgd":"pgd","pgs":"pgs","ecs":"ecs"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/apps/Index.scss
// module id = 1410
// module chunks = 0